const getDefaultState = () => {
  return {
    data: {
      pid: 0,
      eledate: 0,
      mark: 0,
      display: 0,
    },
    token: '',
  }
}

const getters = {
}

const actions = {
  setPid({ commit }, data) {
    commit('SET_PID', data)
  },
  setEledate({ commit }, data) {
    commit('SET_ELEDATE', data)
  },
  setMark({ commit }, data) {
    commit('SET_MARK', data)
  },
  setPack({ commit }, data) {
    commit('SET_PACK', data)
  },
  setToken({ commit }, data) {
    commit('SET_TOKEN', data)
  },
  setDisplay({ commit }, data) {
    commit('SET_DISPLAY', data)
  },
  resetData({ commit }) {
    commit('RESET_DATA')
  },
}

const mutations = {
  SET_PID(state, data) {
    state.data.pid = data
  },
  SET_ELEDATE(state, data) {
    state.data.eledate = data
  },
  SET_MARK(state, data) {
    state.data.mark = data
  },
  SET_PACK(state, data) {
    state.data.pack = data
  },
  SET_TOKEN(state, data) {
    state.token = data
  },
  SET_DISPLAY(state, data) {
    state.data.display = data
  },
  RESET_DATA(state) {
    Object.assign(state, getDefaultState())
  },
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
